/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

export const apiReviewsAutomaticrecordresponseDetailDestroy = (reviewOpk: string) => {
  return HTTP<void>({ url: `/api/v7/reviews/automatic/${reviewOpk}/response/`, method: 'DELETE' });
};

export const getApiReviewsAutomaticrecordresponseDetailDestroyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
    TError,
    { reviewOpk: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
  TError,
  { reviewOpk: string },
  TContext
> => {
  const mutationKey = ['apiReviewsAutomaticrecordresponseDetailDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
    { reviewOpk: string }
  > = (props) => {
    const { reviewOpk } = props ?? {};

    return apiReviewsAutomaticrecordresponseDetailDestroy(reviewOpk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiReviewsAutomaticrecordresponseDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>
>;

export type ApiReviewsAutomaticrecordresponseDetailDestroyMutationError = ErrorType<unknown>;

export const useApiReviewsAutomaticrecordresponseDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
    TError,
    { reviewOpk: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
  TError,
  { reviewOpk: string },
  TContext
> => {
  const mutationOptions = getApiReviewsAutomaticrecordresponseDetailDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
